import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { ModalRedeemInsurancePage } from './modal-redeem-insurance.page';

const routes: Routes = [
  {
    path: '',
    component: ModalRedeemInsurancePage
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class ModalRedeemInsurancePageRoutingModule {}
